var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPineapple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99995 14V17L8.99995 22H15L18 17V14V9H5.99995V14ZM7.99995 11H8.28868L10.8453 15.4282L9.28257 18.1349L7.99995 16.17V13.17V11ZM10.5152 20H13.4848L12 17.4282L10.5152 20ZM13.1547 15.4282L14.7174 18.1349L16 16.17V13.17V11H15.7113L13.1547 15.4282ZM13.4019 11H10.5981L12 13.4282L13.4019 11ZM11 2H13V5H11V2ZM3.50195 5.874L4.91595 4.46L7.03795 6.58L5.62395 7.995L3.50195 5.874ZM16.96 6.582L19.083 4.462L20.496 5.878L18.373 7.998L16.96 6.582Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineapple);
export default __webpack_public_path__ + "static/media/pineapple.0ecca0108c30abef1d73b07e8fe51fd6.svg";
export { ForwardRef as ReactComponent };